export function validateNewPassword(password: string, confirm: string, username: string) {
  const name = username.trim().toLowerCase(); const length = Array.from(password).length;
  if (length < 8 || length > 128 || !password.trim() || /[\uD800-\uDFFF]/u.test(password) || (name && password.toLowerCase().includes(name))) throw new Error('Mật khẩu cần 8–128 ký tự Unicode, không toàn khoảng trắng và không chứa tên đăng nhập.');
  if (password.normalize('NFC') !== confirm.normalize('NFC')) throw new Error('Hai mật khẩu chưa khớp nhau.');
}
